<template>
  <div
    id="events-filter--duration"
    @click.stop.prevent
  >
    <v-list dense>
      <v-list-item class="duration-list-item">
        <v-list-item-content>
          <v-select
            v-model="operator"
            dense
            filled
            color="muted"
            item-color="muted"
            :height="40"
            :items="['Less Than', 'Greater Than']"
            style="color: #535353;"
            @click.stop.prevent
          >
            <template v-slot:append>
              <font-awesome-icon
                icon="chevron-up"
                class="ml-5 operator-icon"
              />
            </template>
          </v-select>
        </v-list-item-content>
      </v-list-item>
      <v-list-item class="duration-list-item">
        <v-list-item-content>
          <v-form
            v-model="isFormValid"
            class="duration-time"
          >
            <v-text-field
              v-model="hour"
              :height="40"
              :rules="[numberRule]"
              placeholder="HH"
              append-icon=""
              color="muted"
              item-color="muted"
              filled
              class="duration-input duration-hour"
              @click.stop.prevent
            />
            <v-text-field
              v-model="minute"
              :height="40"
              :rules="[numberRule]"
              placeholder="MM"
              append-icon=""
              color="muted"
              item-color="muted"
              filled
              class="duration-input duration-minute"
              @click.stop.prevent
            />
            <v-text-field
              v-model="seconds"
              :height="40"
              :rules="[numberRule]"
              placeholder="SS"
              append-icon=""
              color="muted"
              item-color="muted"
              filled
              class="duration-input duration-seconds"
              @click.stop.prevent
            />
          </v-form>
        </v-list-item-content>
      </v-list-item>
      <v-list-item class="apply-btn">
        <v-list-item-content>
          <v-btn
            color="primary"
            :disabled="!isFormValid"
            @click="updateFilter"
          >
            Apply
          </v-btn>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>
<script>
  export default {
    name: 'DurationFilter',
    props: {
      filterKey: String,
    },
    data: () => ({
      hour: null,
      minute: null,
      seconds: null,
      operator: 'Less Than',
      numberRule: v => {
        if (!v.trim()) return true
        return !isNaN(parseFloat(v)) && v >= 0 && v <= 999
      },
      isFormValid: false,
    }),
    methods: {
      updateFilter () {
        const hms = `${this.hour || '00'}:${this.minute || '00'}:${this.seconds || '00'}`
        const seconds = `${this.hmsToSeconds(hms)}`
        const getOperator = this.operator === 'Less Than' ? '<=' : '>='
        // const readableValue = `${this.operator} ${hms}`
        const payload = {
          key: this.filterKey,
          operator: getOperator,
          value: seconds,
          // readableValue,
        }
        this.$emit('apply-duration-filter', payload)
      },
      hmsToSeconds (str) {
        const p = str.split(':')
        let s = 0
        let m = 1
        while (p.length > 0) {
          s += m * parseInt(p.pop(), 10)
          m *= 60
        }
        return s
      },
    },
  }
</script>
<style lang="scss">
#events-filter--duration{
  width: 204px;
  height: 182px;
  overflow-y: hidden;
  .theme--light.v-select .v-select__selection--comma {
    color: #535353;
    font-family: "Degular", sans-serif;
    font-size: 16px;
    letter-spacing: 0.62px;
    line-height: 20px;
  }
  .v-text-field--filled > .v-input__control > .v-input__slot, .v-text-field--full-width > .v-input__control > .v-input__slot, .v-text-field--outlined > .v-input__control > .v-input__slot {
    min-height: unset;
  }
  .operator-icon {
    height: 16px;
    width: 14px;
    color: #535353;
    margin-top: 4px;
  }
  .apply-btn {
    margin-bottom: -10px;
  }
}
.duration-list-item {
  min-height: 30px;
  margin-bottom: -10px;
  height: 69px !important;
  &:first-of-type {
    margin-top: -2px;
  }
}
.duration-time {
  display: flex;
  justify-content: space-around;
  width: 100%;
  margin-bottom: 15px;
  .duration-input {
    display: inline-flex;
    max-width: 51px;
    max-height: 40px;
    font-size: 14px;
    letter-spacing: 1px;
    appearance: none;
  }
  .duration-hour::after {
    content: ':';
    position: relative;
    top: 12px;
    left: 3px;
    font-size: 15px;
  }
  .duration-seconds::before {
    content: ':';
    position: relative;
    top: 12px;
    right: 3px;
    font-size: 15px;
  }
}
</style>
